var clearSafeframes = function clearSafeframes() {
  if (window.$sf && window.$sf.host) {
    window.$sf.host.cleanup();
  }
};

var clearAdContext = function clearAdContext() {
  clearSafeframes();
};

export default clearAdContext;
//# sourceMappingURL=cleaner.js.map